/**
 * 低频的「现在几点」。用服务端时钟（`RoomLink.clock`），不用本机 `Date.now()` ——
 * 两边差几十秒时，「3 分钟前」会变成「刚刚」甚至负数。
 *
 * ★ 与红线 #48 不冲突：那条禁的是把**每帧**变化的量（倒计时环、滑块、筹码滚动）
 *   放进 React state。这里是秒级/分钟级、面板关了就停的低频刷新，
 *   做成 DOM 直写反而更难读也更容易漏掉一处。
 */
import { useEffect, useState } from 'react'

import { useRoomLink } from './roomLink.js'

/**
 * @param active 关掉的面板不该继续跑定时器
 * @param intervalMs 刷新间隔。按文案的最小粒度取：分钟级文案给 30s，10 秒级文案给 5s
 */
export function useTickingNow(active: boolean, intervalMs: number): number {
  const link = useRoomLink()
  const [now, setNow] = useState(() => link.clock.now())

  useEffect(() => {
    if (!active) return undefined
    setNow(link.clock.now())
    const t = setInterval(() => setNow(link.clock.now()), intervalMs)
    return () => clearInterval(t)
  }, [active, intervalMs, link])

  return now
}
